// attribute name constants
export const NAME_ATTRIBUTE_NAME = 'name';
export const GENDER_ATTRIBUTE_NAME = 'gender';
export const PEER_CLASS_ATTRIBUTE_NAME = 'peer_class';
export const PHONE_ATTRIBUTE_NAME = 'cell_phone';

// attribute value constants
export const ANY = 'any';
export const NIL = 'nil';
export const SELECT_DATE = 'select_date';

// antd attribute cascader selection index constants
export const BULK_ATTRIBUTE_NAME_IND = 2;
export const BULK_ATTRIBUTE_VALUE_IND = 3;

export const noop: () => void = () => null;

export const DEFAULT_TIME = '0001-01-01T00:00:00Z';

export const DERIVED_ATTRIBUTE_REGEX = /^--.+--/;
export const IMAGE_FILE_REGEX = /image\/*/;

// urls
export const ASSET_UPLOAD_URL = '/api/v1/asset';
